import { _APIHandler } from "../utils/helper";

let baseUrl = "user_documents";
export const fetchUserDocuments = (queryParams) => _APIHandler.get(`${baseUrl}`, { params: queryParams });
export const createUserDocument = (data) => _APIHandler.post(`${baseUrl}`, data, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});
export const updateUserDocumentStatus = (id, status) => _APIHandler.put(`${baseUrl}/${id}/${status}`);